export class ClxIdChanger {
    private clxChangeId: HTMLElement | null;


    private readonly apiurl: string;

    constructor() {

        this.apiurl = '/api_change_clxid';
        this.clxChangeId = document.getElementById("clxChangeId");
        this.initializeEvent();
    }

    private initializeEvent(): void {
        if (this.clxChangeId) {
            this.clxChangeId.addEventListener("click", (event: MouseEvent) => this.handleClick(event));
        }
    }

    private handleClick(event: MouseEvent): void {
        event.preventDefault();
        const clxNewIdElement = document.getElementById("clxNewId") as HTMLInputElement | null;
        const clxid = clxNewIdElement ? clxNewIdElement.value : "";
        const typ = this.clxChangeId?.dataset.typ || "";

        if (clxid !== "") {
            const data = new FormData();
            data.append('clxid', clxid);
            data.append('typ', typ);

            const myInit: RequestInit = {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: data,
                cache: 'default',
                credentials: 'same-origin'
            };

            fetch(this.apiurl, myInit)
                .then((response) => response.json())
                .then((json) => {
                    if (json.url && json.url !== "") {
                        window.location.href = json.url;
                    } else {
                        alert('ID nicht gefunden');
                    }
                });
        }
    }
}

